import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Card from '../common/Card';

interface Media {
  url: string;
}

interface Project {
  id?: string | number;
  name: string;
  year: any;
  short_description: string;
  media?: {
    desktop_media?: Media[];
    mobile_media?: Media[];
    enable_mux_video: any;
    mux_video?: any;
  };

  slug: any;
}

interface ProjectsSectionProps {
  data: {
    projects: Project[];
    padding: {
      mobile_top_padding: any;
      mobile_bottom_padding: any;
      desktop_top_padding: any;
      desktop_bottom_padding: any;
    };
    __typename: string;
  };
}

const ComponentSectionsFeaturedProjects = ({ data }: ProjectsSectionProps) => {
  const { projects } = data;
  const [top, setTop] = useState('');
  const [bottom, setBottom] = useState('');

  useEffect(() => {
    const updatePadding = () => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        setTop(data.padding?.mobile_top_padding ?? '');
        setBottom(data.padding?.mobile_bottom_padding ?? '');
      } else {
        setTop(data.padding?.desktop_top_padding ?? '');
        setBottom(data.padding?.desktop_bottom_padding ?? '');
      }
    };

    updatePadding(); // Run on mount

    window.addEventListener('resize', updatePadding); // Listen on resize
    return () => window.removeEventListener('resize', updatePadding); // Clean up
  }, [data]);
  return (
    <>
      <section
        className="py-6 md:py-16 home-project"
        id={data?.__typename}
        style={{
          paddingTop: `${top}rem`,
          paddingBottom: `${bottom}rem`,
        }}
      >
        <div className="mx-auto px-4 md:ps-14 lg:ps-24 md:pe-0">
          <div className="flex flex-col md:flex-row flex-wrap justify-between grid-areacls overflow-hidden">
            {projects.map((project, index) => {
              const desktopImage = project.media?.desktop_media?.[0]?.url ?? '/default-desktop.jpg';
              const mobileImage = project.media?.mobile_media?.[0]?.url ?? '/default-mobile.jpg';

              // Use stable key: project.id if available, fallback to `project-name-index`
              const key =
                project.id ?? `${project.name.replace(/\s+/g, '-').toLowerCase()}-${index}`;

              return (
                <div
                  className="project-box hover-project-box relative group cursor-pointer h-[50%]"
                  key={key}
                >
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    aria-label={`Project ${project.name}`}
                  >
                    <Card
                      desktopImageSrc={desktopImage}
                      mobileImageSrc={mobileImage}
                      title={project.name}
                      year={project.year}
                      baseLink={`/projects/${project.slug}`}
                      number={(index + 1).toString().padStart(2, '0')}
                      description={project.short_description}
                      enableMuxVideo={project?.media?.enable_mux_video}
                      muxPlaybackId={project?.media?.mux_video?.playback_id}
                    />
                  </motion.div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default ComponentSectionsFeaturedProjects;
